const PlatformModule = {
    DELIVEROO: 'deliveroo',
    JUST_EATS: 'justeat',
    UBER_EATS: 'ubereats'
}

export default PlatformModule;
